import {
  required,
  requiredIf,
  sameAs,
  email,
  between,
  minLength,
  maxValue,
  integer
} from 'vuelidate/lib/validators'
import {
  phone,
  date,
  time,
  dateAfter,
  dateBefore,
  timeAfter,
  bsoNo
} from '@/ic-common/helpers/validation'
import moment from 'moment'
import intersection from 'lodash/intersection'

const _ = { intersection }

export default {
  form: {
    type: {
      required
    },
    bsoNo: {
      requiredIf: requiredIf(function() {
        return this.form.type === 'group'
      }),
      bsoNo
    },
    participants: {
      required
    },
    reply_via: {
      required
    },
    email: {
      requiredIf: requiredIf(function() {
        return this.form.reply_via === 'email'
      }),
      email
    },
    email_confirm: {
      requiredIf: requiredIf(function() {
        return this.form.reply_via === 'email'
      }),
      sameAsEmail: sameAs('email')
    },
    phone: {
      required,
      phone
    },
    // agreement: {
    //   required
    // },

    connections: {
      required,
      minLength: minLength(1),
      $each: {
        station_from: {
          required
        },
        departure_date: {
          required,
          date,
          dateBefore: dateBefore(moment().add(1,"M").format('YYYY-MM-DD')),
          dateAfter: dateAfter(moment().subtract(1,"D").format('YYYY-MM-DD'))
        },
        departure_time: {
          required,
          time,
          timeAfter8: (value, item) => {

            
            if(document.location.href.indexOf("ic_staff=*") > 0) return true;
            return (
              !value ||
              moment(item.departure_date + ' ' + item.departure_time).isSameOrAfter(
                moment().add(
                  8,
                  'h'
                )
              )
            )
          }
        },
        station_to: {
          required
        },
        arrival_date: {
          required,
          date,
          dateAfter: dateAfter('departure_date')
        },
        arrival_time: {
          required,
          time,
          timeAfter: (value, item) => {
            return (
              !value ||
              moment(item.arrival_date + ' ' + item.arrival_time).isSameOrAfter(
                moment(item.departure_date + ' ' + item.departure_time).add(
                  5,
                  'm'
                )
              )
            )
          }
        },
        carrier: {
          required
        },
        train_no: {
          required
        },
        car_no: {
          integer
        },
        seat_no: {}
      }
    },

    assistance: {
      atStation: {
        required
      },
      inTrain: {
        required
      },
      baggage: {
        required
      },
      baggage_size: {
          requiredIf: requiredIf(function(item) {
            return item.baggage.length && item.baggage[0] != 'na';
          })
        },      
      meetingPlace: {
        required
      },
      meetingPlaceOther: {
        requiredIf: requiredIf(function() {
          return this.form.assistance.meetingPlace === 'other'
        })
      },
      meetingPlaceCashNo: {
        integer,
        requiredIf: requiredIf(function() {
          return this.form.assistance.meetingPlace === 'cash_1'
        })
      }
    },

    persons: {
      required,
      integer
    },

    disabilities: {
      required,
      minLength: minLength(1),
      $each: {
        persons: {
          required,
          integer
        },
        type: {
          required
        },
        equipment: {
          required
        },
        size: {
          requiredIf: requiredIf(function(item) {
            return (
              _.intersection(item.equipment || [], [
                'maunal_wheelchair',
                'electric_wheelchair'
              ]).length > 0
            )
          })
        },
        remarks: {
          requiredIf: requiredIf(function(item) {
            return item.equipment.indexOf('other') > -1 || item.type === 'other'
          })
        }
      }
    }
  }
}
